// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","203":"f4d8d3e0b8adfef3d833","228":"94457da5367e444cbd61","243":"307c1cf31df043fbcfea","556":"50ea6fb2947b9ff0cb46","720":"e986df59120b9443ada3","852":"f4e5150ed9206ecb7fe7"}[chunkId] + ".bundle.js";
};